<template>
    <div :class="{'inline': placement === 'inline'}">
        
        <button
            :style="styleOptions"
            v-tooltip="options"
            :class="{'spaced': space}"
            v-if="identifier !== null && options.content !== null && options.content !== ''"
        >
            <i :class="'fas fa-' + icon" v-if="icon" />
            <i class="fas fa-question" v-else />
        </button>

    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .inline {
        display: inline-block
    }

    button {
        opacity: 0.8;

        &:hover {
            opacity: 1;
        }

        &.spaced {
            margin-right: 6px;
            color: $color--dark;
            opacity: .75;

            &:hover {
                opacity: 1;
            }
        }
    }

</style>

<script>
export default {
    props: {
        // content: String,
        identifier: String,
        placement: String,
        icon: String,
        space: Boolean
    },
    data () {
        return {
            options: {
                content: null,
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip'
                }
            }
        }
    },
    created () {
        if (this.identifier !== null) {
            this.getDataFromContentful()
        }
    },
    methods: {
        getDataFromContentful () {
            const contentful = require('contentful')
            const client = contentful.createClient({
            // This is the space ID. A space is like a project folder in Contentful terms
            space: '3h0kg5qa88is',
            // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
            accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            })
            // This API call will request an entry with the specified ID from the space defined at the top, using a space-specific access token.
            client
            .getEntries({
                content_type: 'informationsbokse',
                // 'fields.relation[in]': 'oekonomi.ebitda'
                'fields.relation[in]': this.identifier
            })
            // .getEntry('4SzlILGMZwweEFr9myvbxT')
            .then(entries => {
                // this.options.content = entries.items[0].fields.forklaring
                if (entries.items[0].fields.htmlForklaring.content.length > 0) {
                    this.options.content = ''
                    this.options.content += '<div style="margin-bottom:-15px;">'
                    entries.items[0].fields.htmlForklaring.content.forEach(content => {
                        if (content.nodeType === 'paragraph') {
                            this.options.content += '<p style="margin-bottom:15px;">' + content.content[0].value + '</p>'
                        } else if (content.nodeType === 'unordered-list') {
                            this.options.content += '<ul style="padding-left:20px;margin-bottom:15px;">'
                            content.content.forEach(listItem => {
                                this.options.content += '<li>' + listItem.content[0].content[0].value + '</li>'
                            })
                            this.options.content += '</ul>'
                        }
                    })
                    this.options.content += '</div>'
                    this.options.content = this.options.content.replace(/(?:\r\n|\r|\n)/g, '<br>')
                }
            })
            .catch(err => console.log(err))
        }
    },
    computed: {
        styleOptions () {
            let cases = {
                left: 'float: left',
                right: 'float: right',
                inline: 'display: inline-block'
            }
            if (!Object.keys(cases).includes(this.placement)) {
                console.log('fejl i placement prop')
                return ''
            }
            return cases[this.placement]
        }
    }
}
</script>



// WEBPACK FOOTER //
// dTooltip.vue?2752193e